import client from '../../base-api';

const serviceURL = '/course-private-learning-coaching';

const coursePrivateLearningCoachingService = {

    getCourses(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getCourse(courseId: number) {
        return client.get(`${serviceURL}/${courseId}`);
    },

    postCourse(courseData: any) {
        return client.post(`${serviceURL}`, courseData);
    },

    putCourse(courseData: any, courseId: number) {
        return client.put(`${serviceURL}/${courseId}`, courseData);
    },

    deleteCourse(courseId: number) {
        return client.delete(`${serviceURL}/delete/${courseId}`);
    },
}

export default coursePrivateLearningCoachingService;